import { useEffect, useRef, useState } from "react";

interface Size {
  width: number | undefined;
  height: number | undefined;
}

function useResizeObserver<T extends HTMLElement = HTMLDivElement>(): [
  React.RefObject<T>,
  Size
] {
  const [size, setSize] = useState<Size>({
    width: undefined,
    height: undefined,
  });
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      if (!Array.isArray(entries) || !entries.length) return;

      const entry = entries[0];
      const { width, height } = entry.contentRect;

      setSize({ width, height });
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref]);

  return [ref, size];
}

export default useResizeObserver;
